import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ReadPage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PublishPageParams {
  pageId: string;
}

export const publishPage = async (params: PublishPageParams): Promise<ReadPage> => {
  return await tinctApi.pages.publishPage(params.pageId);
};

/**
 * Publishes a single variant (the way back from `unpublished`). Publishing a
 * page also brings its campaign back to published, hence the campaign
 * invalidations alongside the page ones.
 */
export const usePublishPage = (
  options?: Omit<
    UseMutationOptions<ReadPage, ApiError, PublishPageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: publishPage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      queryClient.invalidateQueries({ queryKey: ['campaign'] });
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
